export const ONE_DAY = 86400000;
export const ONE_WEEK = 7 * ONE_DAY;
export const TO_DAY = Date.now();
export const ROOM_TYPE = [
  '低级服务器',
  '普通服务器',
  '中级服务器',
  '高级服务器',
  '超级服务器',
];
export const statTxt = ['关闭', '开启', '未开启'];

export const DEFAULT_MAP_IMG =
  '//mnweb.mini1.cn/activity/CreatorCenter/img/img_map_no_url.png';

export function formatTime(time, needSecond) {
  if (('' + time).length < 13) time *= 1000;
  const _date = new Date(time);
  return (
    _date.getFullYear() +
    '-' +
    twoNums(101 + _date.getMonth()) +
    '-' +
    twoNums(100 + _date.getDate()) +
    ' ' +
    (needSecond
      ? '  ' +
        twoNums(100 + _date.getHours()) +
        ':' +
        twoNums(100 + _date.getMinutes()) +
        ':' +
        twoNums(100 + _date.getSeconds())
      : '')
  );
}

function twoNums(num) {
  return ('' + num).slice(-2);
}

export function toFixed(number, digit = 2) {
  if (!number) return '0.00';
  return number.toFixed(digit);
}

export function _setDefaultMapImg(url) {
  if (url) url = url.replace(/^(https|http):/, '');
  const pattern =
    /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/;
  if (pattern.test(url)) {
    url = DEFAULT_MAP_IMG;
  }
  return url || DEFAULT_MAP_IMG;
}
export function isWarnDay(time) {
  if (('' + time).length < 13) time *= 1000;
  const _remainderTime = time - Date.now();
  const remainderDay = Math.round(_remainderTime / ONE_DAY);
  return remainderDay <= 7;
}
